import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/carousel/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p><inlineCode parentName="p">{`CarouselLayout`}</inlineCode>{` is our custom subclass of `}<inlineCode parentName="p">{`UICollectionViewFlowLayout`}</inlineCode>{` that facilitates creation of single line carousels `}<img parentName="p" {...{
        "src": "/1dbf60578760ef2bcce83331da8082d1/carousel.gif",
        "alt": "Carousel"
      }}></img></p>
    <h2>{`Public API`}</h2>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/uikit/uicollectionviewflowlayout"
      }}>{`UICollectionViewFlowLayout`}</a></p>
    <h2>{`Usage`}</h2>
    <p><inlineCode parentName="p">{`CarouselLayout`}</inlineCode>{` can be used to lay out a collection view`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`   import Thumbprint

   /* ... */

   let carouselLayout = CarouselLayout()
   let collectionView = UICollectionView(frame: .zero, collectionViewLayout: carouselLayout)

   // Properties can be modified just like a regular UICollectionViewFlowLayout
   carouselLayout.sectionInset.bottom = Space.three
   carouselLayout.sectionInset.left = Space.four
   carouselLayout.sectionInset.right = Space.four
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      